<template>
  <div class="bg">
    <module-number :numberInfo="numberInfo"></module-number>
    <div class="top-bg">
      <div class="top-left">
        <div class="title-left-img"></div>
        <span @click="pushBackstage('group_basic_info')">{{
          eduInfo.eduBuresuName
        }}</span>
        <div class="title-right-img"></div>
        <div ref="select-1" class="pitch-on-bg" @click="moduleClick(1)">
          <span>安全态势</span>
        </div>
        <div ref="select-2" class="un-pitch-on-bg" @click="moduleClick(2)">
          <span>风险统计</span>
        </div>
        <div ref="select-3" class="un-pitch-on-bg" @click="moduleClick(3)">
          <span>隐患统计</span>
        </div>
        <div ref="select-4" class="un-pitch-on-bg" @click="moduleClick(4)">
          <span>雪亮工程</span>
        </div>
        <div ref="select-5" class="un-pitch-on-bg" @click="moduleClick(5)">
          <span>食堂安全</span>
        </div>
        <div ref="select-6" class="un-pitch-on-bg">
          <el-dropdown>
            <span>安全地图</span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="moduleClick(6,'thoseIn')">总校</el-dropdown-item>
              <el-dropdown-item @click.native="moduleClick(6,'branchSchool')">分校</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div ref="select-7" class="un-pitch-on-bg" @click="moduleClick(7)">
          <span>后台管理</span>
        </div>
      </div>
      <div>
        <the-now-time></the-now-time>
      </div>
    </div>
    <div class="security-situation" @click="moduleClick(1)"></div>
    <div class="risk-statistics" @click="moduleClick(2)"></div>
    <div class="hidden-danger-statistics" @click="moduleClick(3)"></div>
    <div class="safety-center" @click="moduleClick(4)"></div>
    <security-situation
      v-if="sel == 1"
      :infoData="securityData"
    ></security-situation>
    <risk-statistics
      v-if="sel == 2"
      :infoData="riskData"
      :searchParams="riskSearchParams"
      @clickRow="clickRow"
    >
    </risk-statistics>
    <hidden-danger-statistics
      v-if="sel == 3"
      :infoData="hiddenData"
      :searchParams="hiddenSearchParams"
      @clickRow="hClickRow"
    ></hidden-danger-statistics>
    <safety-center v-if="sel == 4"></safety-center>
    <food-statistics v-if="sel == 5"></food-statistics>
    <safety-map v-if="sel == 6" :type='schoolType'></safety-map>
  </div>
</template>
<script>
import TheNowTime from "./components/TheNowTime";
import SecuritySituation from "./components/SecuritySituation";
import riskStatistics from "./components/riskStatistics";
import hiddenDangerStatistics from "./components/hiddenDangerStatistics";
import moduleNumber from "./components/moduleNumber";
import SafetyCenter from "./components/SafetyCenter";
import foodStatistics from "./components/foodStatistics";
import safetyMap from "./components/safetyMap";

export default {
  name: "index",
  components: {
    TheNowTime,
    SecuritySituation,
    riskStatistics,
    hiddenDangerStatistics,
    moduleNumber,
    SafetyCenter,
    foodStatistics,
    safetyMap
  },
  data() {
    return {
      sel: 1,
      securityData: {
        //安全态势
        spectionareasNum: 0, //巡查点总数
        spectionareasHeNum: 0, //巡查上报隐患数量
        patrolStatistics: [], //巡查统计波段图
        hiddenTroubleList: [], //隐患实时动态
        schoolHazardCompletionRate: [], //隐患整改率排行榜
        patrolStatisticsRank: [], //日常巡查完成率
        mainSchoolProportionOfHiddenDangers: [], // 发现隐患类占比数据
        riskLevelCompare: [], //风险四色分布图
        numberOfHiddenDangers: {
          sum: 0,
          generalHiddenDangers: 0,
          majorHiddenDanger: 0
        }
      },
      riskData: {
        //风险统计
        riskDynamicAnalysis: [],
        schoolList: [],
        riskLevelCompare: [],
        riskTypeDynamicAnalysis: [],
        totalRisk: 0, //风险汇总
        greatRisk: 0, //重大风险
        largenRisK: 0, //较大风险
        ordinaryRisk: 0, //一般风险
        lesserRisk: 0 //较低风险
      },
      riskSearchParams: {
        collegeId:'',
        riskLevel:0
      },
      //   隐患统计
      hiddenData: {
        troubleInfo: {},
        schoolList: [],
        dangerDynamicTypes: [],
        troubleStatistics: []
      },
      hiddenSearchParams: {
        status: 0,
        collegeId: "",
        schoolId: ""
      },
      numberInfo: {
        totalRisk: 0, //风险总数量
        totalHiddenDangers: 0, //隐患总数量
        totalDepartments: 0, //学校总数量
        totalMonitoring: 0 //监控总数量
      },
      schoolType:'thoseIn'
    };
  },
  mounted() {
    this.getSecurityData();
    this.getModuleNumber();
  },
  methods: {
    async getModuleNumber() {
      let req = {
        eudId: this.eduInfo.eduId
      };
      let res = await this.$Http.getUniversityNumber(req);
      if (res.code == 200) {
        this.numberInfo = res.data || {
          otalRisk: 0, //风险总数量
          totalHiddenDangers: 0, //隐患总数量
          totalDepartments: 0, //学校总数量
          totalMonitoring: 0 //监控总数量
        };
      } else {
        this.numberInfo = {
          otalRisk: 0, //风险总数量
          totalHiddenDangers: 0, //隐患总数量
          totalDepartments: 0, //学校总数量
          totalMonitoring: 0 //监控总数量
        };
      }
    },
    moduleClick(num,type) {
      for (let index = 0; index < 6; index++) {
        let refs = "select-" + (index + 1);
        if (num == index + 1) {
          this.$refs[refs].className = "pitch-on-bg";
        } else {
          this.$refs[refs].className = "un-pitch-on-bg";
        }
      }
      this.sel = num;
      this.schoolType = type || ''
      switch (num) {
        case 1:
          this.getSecurityData();
          this.getModuleNumber();
          break;
        case 2:
          let req = {
            eduId: this.eduInfo.eduId,
            regionCode: parseInt(this.eduInfo.regionCode),
            eduBuresuType: this.eduInfo.eduBuresuType
          };
          this.getRiskData(req);
          this.getModuleNumber();
          break;
        case 3:
          let reqs = {
            universalId: this.eduInfo.eduId,
            regionCode: parseInt(this.eduInfo.regionCode),
            eduBuresuType: this.eduInfo.eduBuresuType,
            type: 1
          };
          this.getHiddenDangerStatistics(reqs);
          this.getModuleNumber();
          break;
        case 4:
          //   alert("安全中心");
          this.getModuleNumber();
          break;
        case 5:
          //   alert("食堂安全");
          break;
        case 6:
          // alert("安全地图");
          break;
        case 7:
          // alert("后台管理");
          this.pushBackstage("/un_subordinate_school");
          break;
        default:
          break;
      }
    },
    // 安全态势
    async getSecurityData() {
      let req = {
        eudId: this.eduInfo.eduId
      };
      let res = await this.$Http.getUniversityBigData(req, true);
      // console.log(res);
      if (res.code == 200) {
        let data = res.data;
        this.securityData.hiddenTroubleList = data.realTimeDynamic || [];
        this.securityData.schoolHazardCompletionRate =
          data.schoolHazardCompletionRate || [];
        this.securityData.patrolStatisticsRank =
          data.patrolStatisticsRank || [];
        this.securityData.patrolStatistics = data.patrolStatistics || [];
        this.securityData.numberOfHiddenDangers = data.numberOfHiddenDangers || {
          sum: 0,
          generalHiddenDangers: 0,
          majorHiddenDanger: 0
        };
        this.securityData.mainSchoolProportionOfHiddenDangers = [
          {
            value:
              data.mainSchoolProportionOfHiddenDangers[0].generalHiddenDangers,
            name: "一般隐患"
          },
          {
            value:
              data.mainSchoolProportionOfHiddenDangers[0].majorHiddenDanger,
            name: "重大隐患"
          }
        ];
        this.securityData.riskLevelCompare = data.riskLevelCompare || [];
        this.securityData.spectionareasNum = data.spectionareasNum || 0;
        this.securityData.spectionareasHeNum = data.spectionareasHeNum || 0;
      } else if (res.code == 101) {
      } else {
      }
    },
    // 风险统计
    async getRiskData(info) {
      let self = this;
      let req = {collegeId:info.eduId}
      let res = await self.$Http.getCollegeRisk(req);
      if (res.code == 200) {
        let data = res.data;
        // self.riskData.riskDynamicAnalysis = data.riskDynamicAnalysis || [];
        self.riskData.schoolList = data.subSchoolInfo || [];
        // self.riskData.riskLevelCompare = data.riskLevelCompare || [];
        // let riskTypeDynamicAnalysis = data.riskDynamicAnalysis || []
        // self.riskData.riskTypeDynamicAnalysis = riskTypeDynamicAnalysis.filter(
        //   (item) => {
        //     return item.totalNum > 0;
        //   }
        // );
        if (self.riskData.schoolList.length > 0) {
            self.clickRow(self.riskData.schoolList[0])
        }
      } else if (res.code == 101) {
      } else {
      }
    },
    // 隐患统计
    async getHiddenDangerStatistics(req) {
      let res = await this.$Http.getUniversityHiddenData(req);
      if (res.code == 200) {
        let data = res.data;
        this.hiddenData.troubleInfo =
          data.detailsOfUniversityRectification || {};
        this.hiddenData.schoolList = data.universitySchoolSeriesTable || [];
        this.hiddenData.dangerDynamicTypes = [
          {
            name: "地质灾害占比",
            value: data.collegesProportionOfHiddenDangers.genre1 || 0
          },
          {
            name: "卫生食品",
            value: data.collegesProportionOfHiddenDangers.genre2 || 0
          },
          {
            name: "人身安全",
            value: data.collegesProportionOfHiddenDangers.genre3 || 0
          },
          {
            name: "校舍、设施、设备",
            value: data.collegesProportionOfHiddenDangers.genre4 || 0
          },
          {
            name: "水、电",
            value: data.collegesProportionOfHiddenDangers.genre5 || 0
          }
        ];
        this.hiddenData.troubleStatistics =
          data.collegesRegionalHiddenDangerStatistics || [];
        this.hiddenSearchParams.schoolId = req.universalId
      } else if (res.code == 101) {
      } else {
      }
    },
    // 风险统计点击学校列表
    clickRow(info) {
      if (info.schoolId) {
        this.riskSearchParams.collegeId = info.schoolId;
        this.getSchoolRisKInfo(info.schoolId);
      }
    },
    // 隐患统计点击学校列表
    hClickRow(info) {
      this.getEduSchoolHiddenDangerStatistics(info.schoolId);
      this.hiddenSearchParams.collegeId = info.schoolId
    },
    // 点击直属学校查询学校信息
    async getSchoolRisKInfo(schoolId) {
      let req = {
        schoolId: schoolId
      };
      let res = await this.$Http.getSchoolRisKInfo(req);
      if (res.code == 200) {
        let data = res.data;
        this.riskData.riskDynamicAnalysis = data.riskDynamicAnalysis || [];
        this.riskData.riskLevelCompare = data.riskLevelCompare.map((item,index)=>{
            item.index = index
            return item
        });
        this.riskData.riskTypeDynamicAnalysis = data.riskTypeDynamicAnalysis.filter(
          (item) => {
            return item.totalNum > 0;
          }
        );
        this.getRislNum(data.riskTotal || []);
      } else if (res.code == 101) {
      } else {
      }
    },
    // 点击直属学校查询学校信息
    async getEduSchoolHiddenDangerStatistics(schoolId) {
      let req = {
        universalId: schoolId,
        type: 2
      };
      let res = await this.$Http.getUniversityHiddenData(req);
      if (res.code == 200) {
        let data = res.data;
        this.hiddenData.troubleInfo =
          data.detailsOfUniversityRectification || {};
        this.hiddenData.dangerDynamicTypes = [
          {
            name: "地质灾害占比",
            value: data.collegesProportionOfHiddenDangers.genre1
          },
          {
            name: "卫生食品",
            value: data.collegesProportionOfHiddenDangers.genre2
          },
          {
            name: "人身安全",
            value: data.collegesProportionOfHiddenDangers.genre3
          },
          {
            name: "校舍、设施、设备",
            value: data.collegesProportionOfHiddenDangers.genre4
          },
          {
            name: "水、电",
            value: data.collegesProportionOfHiddenDangers.genre5
          }
        ];
        this.hiddenData.troubleStatistics =
          data.collegesRegionalHiddenDangerStatistics || [];
      } else if (res.code == 101) {
      } else {
      }
    },
    getRislNum(list) {
      let self = this;
      list.forEach((element) => {
        if (element.totalType == -1) {
          self.riskData.totalRisk = element.totalNum || 0; //风险汇总
        } else if (element.totalType == 3) {
          self.riskData.greatRisk = element.totalNum || 0; //重大风险
        } else if (element.totalType == 2) {
          self.riskData.largenRisK = element.totalNum || 0; //较大风险
        } else if (element.totalType == 1) {
          self.riskData.ordinaryRisk = element.totalNum || 0; //一般风险
        } else if (element.totalType == 0) {
          self.riskData.lesserRisk = element.totalNum || 0; //较低风险
        }
      });
    },
    // 返回后台
    pushBackstage(url) {
      this.$router.push(url);
    }
  },
  computed: {
    eduInfo() {
      return JSON.parse(sessionStorage.getItem("eduInfo"));
    }
  }
};
var targetHeightScale; //存放缩放的比例
var autoResize = {
  resize: function(docWidth, docHeight, targetSelector) {
    var docScale = docHeight / docWidth,
      designWidth = 1920,
      designHeight = 940,
      els = document.querySelectorAll(targetSelector),
      scale = docWidth / designWidth,
      scaleX = docWidth / designWidth,
      scaleY = docHeight / designHeight,
      _this = this;
    (targetHeightScale = scale), //将缩放比例保存，动态计算宽高时需要使用
      this.convertArray(els).forEach(function(el) {
        _this.extend(el.style, {
          width: designWidth + "px",
          height: docScale * designWidth + "px",
          position: "absolute",
          top: 0,
          left: 0,
          transformOrigin: "0 0",
          webkitTransformOrigin: "0 0",
          transform: "scale(" + scale + ")",
          webkitTransform: "scale(" + scale + ")",
          overflow: "hidden",
          webkitOverflowScrolling: "touch"
        });
      });
  },
  convertArray: function(arrayLike) {
    return Array.prototype.slice.call(arrayLike, 0);
  },
  extend: function() {
    var args = Array.prototype.slice.call(arguments, 0);
    return args.reduce(function(prev, now) {
      for (var key in now) {
        if (now.hasOwnProperty && now.hasOwnProperty(key)) {
          prev[key] = now[key];
        }
      }
      return prev;
    });
  },
  scaleResize: function(clientWidth, clientHeight, targetSelector) {
    window.addEventListener(
      "resize",
      this.resize(clientWidth, clientHeight, targetSelector)
    ); //监听窗口的变化
  }
};
var setElementSize = {
  //参数可选，最多选择5个参数。参数按序赋值，如果不需缩放，scale需传入1
  setSize: function(target, scale, target1, target2, target3) {
    var targetScale = scale || 1; //不传scale，不缩放，默认为1
    var targetHeight;
    if (target) {
      targetHeight = innerHeight / targetScale;
    }
    // console.log(targetHeight)
    // if (target1) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height();
    // }
    // if (target1 && target2 && target3) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height() -  document.querySelector(target2).height() -  document.querySelector(target3).height();
    // } else if (target1 && target2) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height() -  document.querySelector(target2).height();
    // } else if (target1) {
    //     targetHeight = window.height() / targetScale -  document.querySelector(target1).height();
    // }
    document.querySelector(".bigdata_page").style.height = targetHeight;

    // var cancas =  document.getElementsByTagName('canvas')
    // var ss = document.getElementsByTagName('canvas')

    // console.log(ss)

    // document.getElementsByTagName('canvas').setAttribute('height','100%')
    // document.getElementsByTagName('canvas').setAttribute('width','100%')
    // console.log(cancas)
    // cancas.width = '100px'
    // cancas.height = '100px'

    // console.log(123)
    // console.log(document.querySelector('.bigdata_page').offsetHeight)
  }
};
var is_fullScreen = false;

window.onresize = function() {
  if (is_fullScreen) {
    changeHeight();
  } else {
    cancelChangeHeight();
  }
  autoResize.scaleResize(innerWidth, innerHeight, ".bigdata_page");
  setElementSize.setSize(".bigdata_page", targetHeightScale);
  // setElementSize.setSize('.left_top', targetHeightScale, '.top')
  // setElementSize.setSize('.map', targetHeightScale, '.top', '.left_bottom');
  // setElementSize.setSize('.right_body', targetHeightScale, '.top');
};
autoResize.scaleResize(innerWidth, innerHeight, ".bigdata_page");
setElementSize.setSize(".bigdata_page", targetHeightScale);
// 全屏状态时更改高度
function changeHeight() {
  is_fullScreen = true;
}

// 取消全屏时恢复
function cancelChangeHeight() {
  is_fullScreen = false;
}
</script>
<style lang="scss" scoped>
.bg {
  width: 100%;
  height: 100%;
  background: url("~@/assets/img/bigDataCollge/new-bigData-bg.gif") center
    center no-repeat;
  background-size: 100% 100%;
  min-width: 1200px;
  min-height: 768px;
  .top-bg {
    width: 100%;
    height: 56px;
    background-color: rgba(30, 52, 100, 0.8);
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center; /*垂直居中*/
    .top-left {
      display: flex;
      flex-direction: row;
      align-items: center; /*垂直居中*/
      .title-left-img {
        margin-left: 20px;
        background: url("~@/assets/img/bigDataCollge/title-right-img.png")
          center center no-repeat;
        background-size: 100% 100%;
        width: 30px;
        height: 20px;
      }
      span {
        margin: 0px 10px;
        font-size: 22px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #fff7c7;
        cursor: pointer;
      }
      .title-right-img {
        background: url("~@/assets/img/bigDataCollge/title-left-img.png") center
          center no-repeat;
        background-size: 100% 100%;
        width: 30px;
        height: 20px;
      }
      .pitch-on-bg {
        width: 120px;
        height: 40px;
        margin-left: 40px;
        cursor: pointer;
        background: url("~@/assets/img/bigDataCollge/pitch-on-navigation.png")
          center center no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center; /*垂直居中*/
        justify-content: center; /*水平居中*/
        transition: transform 0.3s;
        &:hover {
          transform: scale(1.05);
        }
        span {
          font-size: 16px;
          color: rgba(255, 255, 255, 1);
          font-weight: 700;
        }
      }
      .un-pitch-on-bg {
        width: 120px;
        height: 40px;
        margin-left: 40px;
        cursor: pointer;
        background: url("~@/assets/img/bigDataCollge/un-pitch-on-navigation.png")
          center center no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center; /*垂直居中*/
        justify-content: center; /*水平居中*/
        transition: transform 0.3s;
        &:hover {
          transform: scale(1.05);
        }
        span {
          font-size: 16px;
          color: rgba(255, 255, 255, 1);
          font-weight: 500;
        }
      }
    }
  }
  .security-situation {
    width: 270px;
    height: 166px;
    cursor: pointer;
    position: absolute;
    top: 262px;
    left: 772px;
  }
  .risk-statistics {
    width: 324px;
    height: 174px;
    cursor: pointer;
    position: absolute;
    top: 129px;
    left: 1038px;
  }
  .hidden-danger-statistics {
    width: 246px;
    height: 140px;
    cursor: pointer;
    position: absolute;
    top: 144px;
    left: 1430px;
  }
  .safety-center {
    width: 268px;
    height: 162px;
    cursor: pointer;
    position: absolute;
    top: 360px;
    left: 1250px;
  }
}
</style>
